import type { Client } from '@api/functions';
import { OfferType } from '@shared/types/invoice';

import { client as defaultClient } from '../client';

export async function getOfferProducts(offerType: OfferType) {
    return defaultClient.GET('/offer/{offerType}', {
        params: {
            path: {
                offerType,
            },
        },
    });
}
export async function applyPromo(timePackageId: string) {
    return defaultClient.POST('/offer/timePackage/{productId}/apply', {
        params: {
            path: {
                productId: timePackageId,
            },
        },
        body: {},
    });
}

export async function checkGift(client?: Client) {
    return (client || defaultClient).POST('/offer/gift', {});
}

